import { Layers } from "lucide-react";
import { slug } from "./mapaUtils";

export default function MapaLegenda({ title, entries, hidden, onToggle, heat }) {
  return (
    <div
      className="relative w-full md:absolute md:top-3 md:right-3 z-[500] md:w-64 rounded-xl border border-white/10 bg-background/80 backdrop-blur-xl p-3 shadow-2xl"
      data-testid="mapa-legenda"
    >
      <div className="flex items-center gap-2 text-[11px] uppercase tracking-wider font-semibold text-muted-foreground mb-2">
        <Layers className="w-3.5 h-3.5" /> {title}
      </div>
      <ul className="space-y-1 max-h-56 overflow-y-auto thin-scroll">
        {entries.map((e) => {
          const off = hidden.has(e.key);
          return (
            <li key={e.key}>
              <button
                type="button"
                onClick={() => onToggle(e.key)}
                data-testid={`legenda-item-${slug(e.key)}`}
                className={`w-full flex items-center gap-2 rounded-md px-2 py-1 text-left text-xs transition-opacity hover:bg-muted/60 ${off ? "opacity-40" : ""}`}
                title={off ? "Mostrar no mapa" : "Ocultar do mapa"}
              >
                <span className="w-3 h-3 rounded-full shrink-0 ring-2 ring-background" style={{ background: e.color }} />
                <span className="flex-1 truncate">{e.label}</span>
                <span className="tabular-nums font-semibold" data-testid={`legenda-count-${slug(e.key)}`}>{e.count}</span>
              </button>
            </li>
          );
        })}
      </ul>
      {heat && (
        <div className="mt-3 pt-3 border-t border-border" data-testid="mapa-calor-legenda">
          <div className="text-[11px] font-semibold mb-1.5">
            Calor · {heat.metric === "clientes" ? "clientes fechados" : "vendas realizadas"} ({heat.total})
          </div>
          <div className="h-2 rounded-full" style={{ background: "linear-gradient(90deg,#0ea5e9,#10b981,#facc15,#f97316,#ef4444)" }} />
          <div className="flex justify-between text-[10px] text-muted-foreground mt-1"><span>Menos</span><span>Mais</span></div>
        </div>
      )}
      <p className="text-[10px] text-muted-foreground mt-2 leading-snug">
        Toque num item para ocultar/mostrar. Pino tracejado = localização aproximada.
      </p>
    </div>
  );
}
